import { useContext } from 'react';

import { RegionSeasonContext } from '@/contexts/region-season-context/region-season-context';

const useCachedRegionSeason = () => {
  const ctx = useContext(RegionSeasonContext);

  if (!ctx) {
    throw new Error(
      'useCachedRegionSeason must be used within an RegionSeasonContext'
    );
  }

  return ctx;
};

export default useCachedRegionSeason;
